export const ENDPOINT = {
    HOSPITAL_LOGIN: "/hospital/login",
    HOSPITAL: "/hospital",
    PATIENT: "/hospital/referred_patients",
    PATIENT_DETAILS: "/hospital/patients_details_testlist",
    PATIENT_RECORD: "/footform",
    FORM_VIEWED: "/footform/form_viewed",
    STATUS: "/footform/form_accept_reject",
    DOCTOR_COMMENTS: "/doctorcomments",
    FEEDBACK: "/feedback",
    RESET_EMAIL_LINK :"/forget_password/request_reset_password",
    VALIDATE_TOKEN: "/forget_password/is_token_vailed",
    CHANGE_PASSWORD: "/forget_password/reset_password",
}
